export enum PaymentMethod {
  none = 0,
  credito,
  boleto,
  debito,
  pix
}

export interface ApiPlan {
  id: number
  name: string
  container: number
  containerFormat: string
  amount: string
  status: string
  estimatedAmountPerMonth: string
  estimatedAmount: string
  amountByPeriods: AmountByPeriod[]
}

export interface AmountByPeriod {
  estimatedAmount: string
  estimatedAmountPerMonth: string
  period: string
  periodFormat: string
}

export interface ApiPlanList {
  totalCount: number
  initialItemCurrentPage: number
  pageCount: number
  page: number
  pageSize: number
  filter: string
  items: ApiPlan[]
}

export interface ApiSubscriptionPeriod {
  id: number
  period: string
  percentageDiscount: number
}

export interface ApiSubscriptionInvoice {
  amount: number
  amountFormat: string
  billId: number
  boletoBarcode: string
  boletoUrl: string
  expirationDate: string
  expirationDateFormat: string
  status: number
  statusFormat: string
  pixCopyPasteCode: string
  pixQrCode: string
  plan: string
}

export interface ApiSubscriptionStatus {
  name: string
  container: number
  containerFormat: string
  amount: number
  amountFormat: string
  isRandom: boolean
  isRandomFormat: string
  dateCreated: string
  dateCreatedFormat: string
  period: number
  periodFormat: string
  paymentMethod: number
  paymentMethodFormat: string
  cardId: number,
  cardNumber: string
  cardBrand: string
  benefit: ApiSubscriptionBenefit
  notGenerateBilling: boolean
}

export interface ApiSubscriptionBenefit {
  bonusAmountMonth: number
  percentageDiscountQuotations: number
  percentageDiscountPublicity: number
  maxNumberOfServiceType: number
  maxNumberOfPhoto: number
  maxNumberOfState: number
  maxNumberOfCityByState: number
  priorityToReceiveQuotations: number
  accountManager: boolean
  integrationWithSocialNetworks: boolean
  advancedSEO: boolean
  phoneNumberIsVisible: boolean
  blogService: boolean
  quotationProfile: boolean
  freeQuotationQuenUserSelectCompany: boolean
  technicalSupportLevel: number
}

export interface ApiSubscriptionPayment {
  planId: number
  creditCardId: number
  periodId: number
  type: PaymentMethod
}

export interface ApiSubscriptionEstimate {
  planId: number
  name: string
  periodId: number
  period: string
  amount: string
  discountPercentage: number
}

export interface ApiSignalRPostback {
  success: boolean
}